module.exports = __webpack_public_path__ + "img/pdf.2678f070.svg";